import { ReportingState, GlobalState } from '@/types/state'
import * as actionTypes from '@/store/action-types'

import axios from '@/plugins/axios'
import ReservationByDay, { ReservationByDayResponse } from '@/model/reporting/ReservationByDay'
import BoarderReservationStatusByMonth, { BoarderReservationStatusByMonthResponse } from '@/model/reporting/BoarderReservationStatusByMonth'
import BoarderMonthlyReservationStatusByDay, { BoarderMonthlyReservationStatusByDayResponse } from '@/model/reporting/BoarderMonthlyReservationStatusByDay'

const state: ReportingState = {}

const getters = {}

const mutations = {}

const actions = {
  async [actionTypes.REPORTING_FETCH_RESERVATION_BY_DAY] ({ rootState }: { rootState: GlobalState }, payload: any): Promise<ReservationByDay[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/reporting/reservation-by-day`, {
      cancelToken: payload.cancelToken,

      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        date: payload.date
      }
    })

    return ReservationByDay.createFromResponse(response.data as ReservationByDayResponse)
  },
}

const reportingModule = {
  state,
  getters,
  mutations,
  actions
}

export default reportingModule
